import { Avatar } from '@calendly/ui/components/avatar';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
export const MENU_ID = 'main-user-menu';
export const MENU_TOGGLE_ID = 'main-user-menu-toggle';
const menuControlCss = "m1ghfmbt";
export const MenuControl = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(menuControlCss, props.className)} />);
const userAvatarExpandedCss = "u6jph5f";
const userAvatarCss = "ukucaih";
export const UserAvatar = forwardRef((props, ref) => {
  const {
    expanded,
    ...restProps
  } = props;
  return <FullStoryExclude>
      <Avatar ref={ref} {...restProps} className={classNames(userAvatarCss, {
      [userAvatarExpandedCss]: expanded
    }, props.className)} />
    </FullStoryExclude>;
});
const menuContainerCss = "m11es3uz";
export const MenuContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(menuContainerCss, props.className)} />;
});
const menuContentCss = "mjjsqrv";
export const MenuContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(menuContentCss, props.className)} />;
});
const menuItemCss = "mc6julu";
export const MenuItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(menuItemCss, props.className)} />);
const customBadgeCss = "cyjq4wo";
export const CustomBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(customBadgeCss, props.className)} />;
});

require("./constants.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./constants.js");